import { render } from "./SVGDelete.vue?vue&type=template&id=37f734fa"
import script from "./SVGDelete.vue?vue&type=script&lang=js"
export * from "./SVGDelete.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__